<template>
  <div class="app-container">
    <Table
      ref="tableRef"
      :showSearchIcon="true"
      :isSelect="true"
      :data="tableData"
      :columns="columns"
      :total="total"
      :loading="loading"
      tableName="productInfo"
      exportDataUrl="/warehouseProduct/selectWarehouseProduct"
      @onSearch="handleSearch"
    >
      <template #funBtn>
        <el-row :gutter="8">
          <el-col :span="1.5">
            <el-button
              type="primary"
              icon="Plus"
              @click="handleAdd"
              v-hasPermi="['basicData::productInfo::add']"
              >新增</el-button
            >
          </el-col>
          <el-col :span="1.5">
            <FileUploadTemplateDownload
              btn-type="primary"
              show-name="导入"
              download-name="模板"
              :show-icon="true"
              action-addr="/warehouseProduct/importWarehouseProductExcel"
              download-addr="https://fangererpdata-1351264140.cos.ap-beijing.myqcloud.com/excel/%E4%BA%A7%E5%93%81%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx"
              v-hasPermi="['basicData::productInfo::import']"
              @onErrorList="onShowUploadErrorList"
              @success="handleSuccess"
            />
          </el-col>
        </el-row>
      </template>
    </Table>
    <AddUpdate
      v-model="addUpdateOpen"
      :data="addUpdateData"
      :title="addUpdateTitle"
      @success="handleSuccess"
    />
    <!-- 导入失败信息对话框 -->
    <Dialog
      :title="errTitle"
      :modelValue="importOpen"
      :showClosed="false"
      confirmText="关闭"
      @onConfirm="handleCloadImportErr"
    >
      <template #content>
        <simpleTable
          :data="importErrorData"
          :columns="errTableColumns"
          :isSelect="false"
        />
      </template>
    </Dialog>
  </div>
</template>

<script setup>
import Table from "@/components/Element/Table";
import simpleTable from "@/components/Element/Table/Table/index.vue";
import FileUploadTemplateDownload from "@/components/uploadDownload/fileUploadTemplateDownload.vue";
import AddUpdate from "./AddUpdate";
import { ref } from "vue";
import { listProduct, deleteProduct } from "@/api/warehouse/product";
import { getCustomTableCols } from "@/tableColumn";
import { confirmBoxFun, errorMsg } from "@/utils/msgBox";
import Dialog from "@/components/Element/Dialog";

/**仅支持 Vue 3.3+  配置name 为了是 keep-alive :include 生效 */
defineOptions({
  name: "productInfo",
});

const tableData = ref([]);
const tableRef = ref(null);

const total = ref(0);
const loading = ref(false);
const addUpdateData = ref({});
const addUpdateOpen = ref(false);
const addUpdateTitle = ref("新增");

// 搜索
const handleSearch = (data) => {
  loading.value = true;
  listProduct(data)
    .then((res) => {
      tableData.value = res.data;
      total.value = res?.pageParam?.totleInfo ? res.pageParam.totleInfo : 0;
    })
    .catch((res) => {})
    .finally(() => {
      loading.value = false;
    });
};

const handleAdd = () => {
  addUpdateTitle.value = "新增";
  addUpdateData.value = {};
  addUpdateOpen.value = true;
};

// 导入
const errTitle = ref("");
const importOpen = ref(false);
const importErrorData = ref([]);
const errTableColumns = [
  {
    label: "错误信息",
    prop: "value",
  },
];
const handleCloadImportErr = () => {
  importOpen.value = false;
};
const onShowUploadErrorList = (data) => {
  console.log("导入错误信息", data);
  errorMsg(data.message);
  const errList = [];
  data.errorMessages.forEach((err) => {
    errList.push({
      value: err,
    });
  });
  importErrorData.value = errList;
  errTitle.value = `导入错误：共${data.totalCount}行数据，${data.errorCount}行错误`;
  importOpen.value = true;
};

// 修改
const handleUpdate = (event, row) => {
  addUpdateTitle.value = "修改";
  addUpdateData.value = row;
  addUpdateOpen.value = true;
};

const handleSuccess = () => {
  tableRef.value.onSearch();
};

const handleDelete = (event, row) => {
  confirmBoxFun(() => {
    deleteProduct(row.productId)
      .then((res) => {
        tableRef.value.onSearch();
      })
      .catch((res) => {});
  }, "是否确定要删除此产品？");
};

const columns = getCustomTableCols([
  "productName",
  "classification",
  "productType",
  "supplier",
  "supplierModel",
  "internalModel",
  "usageType",
  // "productUnit",
  "imageUrl",
  "operatorName",
  "operateTime",
  {
    label: "操作",
    prop: "action",
    type: "action",
    search: false,
    action: [
      {
        control: "button",
        controlName: "修改",
        controlType: "success",
        controlText: true,
        controlPermission: ["basicData::productInfo::update"],
        controlFun: handleUpdate,
      },
      {
        control: "button",
        controlName: "删除",
        controlType: "danger",
        controlText: true,
        controlPermission: ["basicData::productInfo::delete"],
        controlFun: handleDelete,
      },
    ],
  },
]);
</script>

<style lang="scss" scoped></style>
